import { useListView } from '../../core/ListViewProvider'
import { UsersListToolbar } from './UserListToolbar'
import { UsersListGrouping } from './UsersListGrouping'
import { PacientesListSearchComponent } from './PacientesListSearchComponent'

const PacientesListHeader = () => {
  const { selected } = useListView()

  // Com linhas selecionadas, a barra de seleção (ações em lote) toma o lugar de "Adicionar".
  return (
    <div className='card-header border-0 pt-6'>
      <PacientesListSearchComponent
        actions={selected.length > 0 ? <UsersListGrouping /> : <UsersListToolbar />}
      />
    </div>
  )
}

export { PacientesListHeader }
